import authFetch from "./Interceptor";


class Backend {

    static async getData(uri) {
        // const l = new LoadingBarComponent();
        // l.callEvent(true);
        // console.log("called new request");
        if (typeof uri === 'undefined' || uri === null) {
            return 'Keinen URI gesendet!';
        }

        return await authFetch.get(uri).then(function success(response) {
            // l.callEvent(false)
            return response.data;
        }).catch(function (error) {
            // l.callEvent(false)
            return Promise.reject(error);
        });
    }

    static async postData(uri, data) {
        // console.log(uri);
        if (typeof uri === 'undefined' || uri === null) {
            return 'Keinen URI gesendet!';
        }

        if (typeof data == 'undefined' || data === null) {
            return 'Keine Daten gesendet!';
        }

        return await authFetch.post(uri, data).then(function success(response) {
            return response.data;
        }).catch(function (error) {
            return Promise.reject(error);
        });
    }

    static async putData(uri, data) {
        if (typeof uri === 'undefined' || uri === null) {
            return 'Keinen URI gesendet!';
        }

        if (typeof data == 'undefined' || data === null) {
            return 'Keine Daten gesendet!';
        }

        return await authFetch.put(uri, data).then(function success(response) {
            return response.data;
        }).catch(function (error) {
            return Promise.reject(error);
        });
    }

    static async deleteData(uri) {
        if (typeof uri === 'undefined' || uri === null) {
            return 'Keinen URI gesendet!';
        }

        return await authFetch.delete(uri).then(function success(response) {
            return response.data;
        }).catch(function (error) {
            return Promise.reject(error);
        });
    }
}

export default Backend;